module.exports = __webpack_public_path__ + "static/media/logo.d8101272.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 137
// module chunks = 2